import React from 'react';
import { Box } from '@mui/material';
import Seo from './Seo';

const TermsOfService = () => {
  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <Seo
        title="Terms of Service"
        description="Terms of Service for the New Mt. Zion Missionary Baptist Church website."
        path="/terms-of-service"
      />
      <div className="contactus-hero">Terms of Service</div>
      <Box
        sx={{
          maxWidth: 900,
          padding: { xs: '1.5rem', md: '3rem' },
          lineHeight: 1.8,
          color: '#333',
        }}
      >
        <p style={{ color: '#777', marginBottom: '2rem' }}>
          Last Updated: February 26, 2026
        </p>

        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing and using the New Mt Zion Missionary Baptist Church
          Lakeland website (&quot;nmzlakeland.org&quot;), you agree to be bound
          by these Terms of Service. If you do not agree with any part of these
          terms, please do not use our website.
        </p>

        <h2>2. Use of Website</h2>
        <p>
          This website is operated by New Mt Zion Missionary Baptist Church,
          located at 1321 N. Webster Avenue, Lakeland, FL 33805. The website is
          intended to provide information about our church, worship services,
          ministries, events, and to facilitate communication with our
          congregation and community.
        </p>
        <p>
          You agree to use this website only for lawful purposes and in a manner
          that does not:
        </p>
        <ul>
          <li>Violate any applicable local, state, or federal laws</li>
          <li>Infringe upon the rights of others</li>
          <li>Interfere with or disrupt the website or its servers</li>
          <li>
            Attempt to gain unauthorized access to any part of the website
          </li>
          <li>
            Use the website to transmit any harmful, threatening, or offensive
            content
          </li>
        </ul>

        <h2>3. Online Donations</h2>
        <p>
          Our website may provide the ability to make online donations to the
          church. All donations are voluntary and processed through secure
          third-party payment services. By making a donation, you confirm that
          you are authorized to use the payment method provided. Refund requests
          for donations should be directed to the church office at (863)
          686-6793 or info@nmzlakeland.org.
        </p>

        <h2>4. User-Submitted Content</h2>
        <p>
          When you submit information through our contact forms, event
          registrations, volunteer applications, or other forms on this website,
          you grant New Mt Zion Missionary Baptist Church the right to use that
          information for the purposes described at the time of collection. You
          are responsible for ensuring the accuracy of the information you
          provide.
        </p>

        <h2>5. Intellectual Property</h2>
        <p>
          All content on this website, including but not limited to text,
          images, logos, graphics, sermon recordings, and videos, is the
          property of New Mt Zion Missionary Baptist Church Lakeland or its
          content creators and is protected by copyright laws. You may not
          reproduce, distribute, or use any content from this website without
          prior written permission from the church.
        </p>

        <h2>6. Third-Party Links</h2>
        <p>
          Our website may contain links to third-party websites, including
          social media platforms such as YouTube and Facebook. We are not
          responsible for the content, privacy practices, or terms of service of
          these third-party sites. We encourage you to review the terms and
          privacy policies of any third-party websites you visit.
        </p>

        <h2>7. Disclaimer of Warranties</h2>
        <p>
          This website is provided on an &quot;as is&quot; and &quot;as
          available&quot; basis. New Mt Zion Missionary Baptist Church makes no
          warranties, expressed or implied, regarding the accuracy, reliability,
          or availability of the website or its content. We reserve the right to
          modify or discontinue any part of the website at any time without
          notice.
        </p>

        <h2>8. Limitation of Liability</h2>
        <p>
          New Mt Zion Missionary Baptist Church shall not be liable for any
          direct, indirect, incidental, or consequential damages arising from
          your use of this website or any content, services, or information
          obtained through it.
        </p>

        <h2>9. Changes to Terms</h2>
        <p>
          We reserve the right to update or modify these Terms of Service at any
          time. Changes will be posted on this page with an updated &quot;Last
          Updated&quot; date. Your continued use of the website after any
          changes constitutes acceptance of the updated terms.
        </p>

        <h2>10. Contact Information</h2>
        <p>
          If you have any questions about these Terms of Service, please contact
          us:
        </p>
        <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
          <li>
            <strong>New Mt Zion Missionary Baptist Church</strong>
          </li>
          <li>1321 N. Webster Avenue, Lakeland, FL 33805</li>
          <li>Phone: (863) 686-6793</li>
          <li>Email: info@nmzlakeland.org</li>
        </ul>
      </Box>
    </div>
  );
};

export default TermsOfService;
